
/*
Onboarding status get error codes
*/
export const ERROR_CODE_HOTEL_NOT_FOUND_IN_HDS = 'HOTEL_NOT_FOUND_IN_HDS'
export const ERROR_CODE_HOTEL_NOT_FOUND = 'HOTEL_NOT_FOUND'
export const ERROR_CODE_HOTEL_STATUS_NOT_VALID_IN_HDS = 'HOTEL_STATUS_NOT_VALID_IN_HDS'
export const ERROR_CODE_HOTEL_READY_FOR_ONBOARDING = 'HOTEL_READY_FOR_ONBOARDING'

export const ERRORS_CODES_NO_ASSOCIATED_APPLICATIONS = [ERROR_CODE_HOTEL_NOT_FOUND_IN_HDS, ERROR_CODE_HOTEL_NOT_FOUND, ERROR_CODE_HOTEL_STATUS_NOT_VALID_IN_HDS]



